import { APP_ERROR, APP_ERROR_CLEAR } from "../actions/actions.types";

const INITIAL_STATE = {
    location: null,
    err: null
}

const errorReducer = (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case APP_ERROR:
            return {
                location: action.payload.location,
                err: action.payload.err
            }

        case APP_ERROR_CLEAR:
            return INITIAL_STATE;

        default:
            return state
    }
}

export default errorReducer;